import { Button, Modal } from 'antd-mobile'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { openBtokVipPurchaseActivity } from '@/utils/native/func'

interface DialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const DialogVipSetting: React.FC<DialogProps> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  return (
    <Modal
      visible={open}
      closeOnMaskClick={true}
      onClose={() => {
        onOpenChange(false)
      }}
      maskClassName="__CustomMask__bg"
      content={
        <div className="p-1">
          <div className="text-center text-base font-medium mb-3">{t('common.vipSettingTip')}</div>
          <div className="flex items-center gap-3">
            <Button
              type="button"
              onClick={() => {
                onOpenChange(false)
              }}
              className="grow-2 h-12 rounded-full text-[#682B01] text-base bg-gradient-to-r from-[rgba(254,153,33,0.1)] to-[rgba(255,66,59,0.1)] border-0">
              {t('common.cancel')}
            </Button>
            <Button
              type="button"
              className="grow-1 h-12 rounded-full text-white text-base bg-gradient-to-r from-[rgba(254,153,33,1)] to-[rgba(255,66,59,1)] border-0"
              onClick={() => {
                openBtokVipPurchaseActivity()
                onOpenChange(false)
              }}>
              {t('common.jumpSet')}
            </Button>
          </div>
        </div>
      }></Modal>
  )
}

export default DialogVipSetting
